// extracted by mini-css-extract-plugin
export default {"compositeFieldBox":"FormFieldGroup_compositeFieldBox__FK4e2"};